// TODO - remove lint disable when editing this file
/* eslint-disable */

export default function storyDataToAns(data) {
  return {
    storyNote: data.storyNote ? data.storyNote.trim() : '',
  }
}
